import { render, staticRenderFns } from "./ProgressAlbum.vue?vue&type=template&id=09a6f386&scoped=true&"
import script from "@/views/Users/Student/Progress/ProgressAlbum.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Progress/ProgressAlbum.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/Progress/progress-album.scss?vue&type=style&index=0&id=09a6f386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a6f386",
  null
  
)

export default component.exports